import React from "react";
import { Box, Typography, Container, useTheme, Button } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { BackButton } from "../../ui/buttons/Buttons";

const NoDataScreenCover = ({ showBackButton = true, customTitle=null, customSubtitle=null, sx={} }) => {
  const { palette } = useTheme();

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: 4,
        mb: 4,
        ...sx
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
          borderRadius: 2,
          textAlign: "center",
          border: `3px solid ${palette.primary[400]}`,
        }}
      >
        <WarningIcon sx={{ fontSize: 60, mb: 2, color: "error.main" }} />
        <Typography variant="h4" component="div" gutterBottom>
          {customTitle ?? 'No Data Loaded'}
        </Typography>
        <Typography variant="body1">
          {customSubtitle ?? 'could not find any data to display'}
        </Typography>
        {showBackButton ? (
          <BackButton
            title="Back"
            disabled={false}
            sx={{
              mt: 1,
            }}
          />
        ) : (
          false
        )}
      </Box>
    </Container>
  );
};

export default NoDataScreenCover;
